export const TarifOnlineLink =
  'https://autoversicherung.vwfs.de/vwfs-kfz/init/view/5eb09f/?traci_s=MI:VW:ORG:VWFS:Website:2021:vwfs_lead&traci_ie=/auto-versichern/kfz-versicherung.html:content:logo:1';

export const InsuranceCallButtonLink = 'tel:03020164026';
